
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caption-styles",
      function () {
        return require("private-next-pages/caption-styles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/caption-styles"])
      });
    }
  